module["exports"] = [
  "پس انداز",
  "سرمایه گذاری",
  "وام مسکن",
  "کارت اعتباری",
  "وام خودرو",
  "وام شخصی"
];
